// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Contenedor Principal de la Sección ===== */
.Beneficios_benefitsSection__JuhGy {
  padding: 80px 5%;
  background-color: var(--azulCielo);
}

.Beneficios_container__10hvC {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr; /* Dos columnas iguales */
  gap: 60px;
}

/* ===== Estilo de cada Columna (Artículo) ===== */
.Beneficios_column__tzjOS {
  display: flex;
  flex-direction: column;
}

.Beneficios_title__YPF9c {
  font-size: 32px;
  font-weight: 800;
  color: var(--textoNegro);
  margin-bottom: 40px;
}

/* ===== Lista de Beneficios ===== */
.Beneficios_benefitsList__fFmkh {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.Beneficios_benefitItem__mdvP1 {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

/* Contenedor del ícono */
.Beneficios_iconWrapper__mBNrP {
  flex-shrink: 0; /* Evita que el ícono se encoja */
  width: 50px;
  height: 50px;
  background-color: rgba(255, 59, 0, 0.1); /* Naranja transparente */
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.Beneficios_iconWrapper__mBNrP svg {
  width: 24px;
  height: 24px;
  color: var(--naranja);
}

/* Contenido de texto del beneficio */
.Beneficios_benefitContent__fB9t- h3 {
  font-size: 18px;
  font-weight: 700;
  color: var(--textoNegro);
  margin-bottom: 8px;
}

.Beneficios_benefitContent__fB9t- p {
  font-size: 16px;
  color: #555;
  line-height: 1.6;
}

/* ===== Botón de Llamada a la Acción (CTA) ===== */
.Beneficios_ctaLink__HlIaC {
  margin-top: auto; /* Empuja el botón al final de la columna */
  padding-top: 30px; /* Espacio sobre el botón */
  background-color: var(--naranja);
  color: var(--textoBlanco);
  padding: 12px 25px;
  border-radius: 5px;
  font-weight: 600;
  text-align: center;
  transition: all 0.3s ease;
}

.Beneficios_ctaLink__HlIaC:hover {
  background-color: var(--azul);
  color: var(--textoBlanco);
}

/* ======================================= */
/* ===== MEDIA QUERY PARA MÓVILES ===== */
/* ======================================= */
@media (max-width: 767px) {
  .Beneficios_benefitsSection__JuhGy {
    padding: 60px 5%;
  }
  .Beneficios_container__10hvC {
    grid-template-columns: 1fr; /* Una sola columna */
    gap: 50px;
  }
  .Beneficios_title__YPF9c {
    font-size: 28px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Beneficios.module.css"],"names":[],"mappings":"AAAA,mDAAmD;AACnD;EACE,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B,EAAE,yBAAyB;EACzD,SAAS;AACX;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA,yBAAyB;AACzB;EACE,cAAc,EAAE,iCAAiC;EACjD,WAAW;EACX,YAAY;EACZ,uCAAuC,EAAE,yBAAyB;EAClE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,mDAAmD;AACnD;EACE,gBAAgB,EAAE,2CAA2C;EAC7D,iBAAiB,EAAE,2BAA2B;EAC9C,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA,4CAA4C;AAC5C,yCAAyC;AACzC,4CAA4C;AAC5C;EACE;IACE,gBAAgB;EAClB;EACA;IACE,0BAA0B,EAAE,qBAAqB;IACjD,SAAS;EACX;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* ===== Contenedor Principal de la Sección ===== */\n.benefitsSection {\n  padding: 80px 5%;\n  background-color: var(--azulCielo);\n}\n\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: 1fr 1fr; /* Dos columnas iguales */\n  gap: 60px;\n}\n\n/* ===== Estilo de cada Columna (Artículo) ===== */\n.column {\n  display: flex;\n  flex-direction: column;\n}\n\n.title {\n  font-size: 32px;\n  font-weight: 800;\n  color: var(--textoNegro);\n  margin-bottom: 40px;\n}\n\n/* ===== Lista de Beneficios ===== */\n.benefitsList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n}\n\n.benefitItem {\n  display: flex;\n  gap: 20px;\n  align-items: flex-start;\n}\n\n/* Contenedor del ícono */\n.iconWrapper {\n  flex-shrink: 0; /* Evita que el ícono se encoja */\n  width: 50px;\n  height: 50px;\n  background-color: rgba(255, 59, 0, 0.1); /* Naranja transparente */\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.iconWrapper svg {\n  width: 24px;\n  height: 24px;\n  color: var(--naranja);\n}\n\n/* Contenido de texto del beneficio */\n.benefitContent h3 {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--textoNegro);\n  margin-bottom: 8px;\n}\n\n.benefitContent p {\n  font-size: 16px;\n  color: #555;\n  line-height: 1.6;\n}\n\n/* ===== Botón de Llamada a la Acción (CTA) ===== */\n.ctaLink {\n  margin-top: auto; /* Empuja el botón al final de la columna */\n  padding-top: 30px; /* Espacio sobre el botón */\n  background-color: var(--naranja);\n  color: var(--textoBlanco);\n  padding: 12px 25px;\n  border-radius: 5px;\n  font-weight: 600;\n  text-align: center;\n  transition: all 0.3s ease;\n}\n\n.ctaLink:hover {\n  background-color: var(--azul);\n  color: var(--textoBlanco);\n}\n\n/* ======================================= */\n/* ===== MEDIA QUERY PARA MÓVILES ===== */\n/* ======================================= */\n@media (max-width: 767px) {\n  .benefitsSection {\n    padding: 60px 5%;\n  }\n  .container {\n    grid-template-columns: 1fr; /* Una sola columna */\n    gap: 50px;\n  }\n  .title {\n    font-size: 28px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"benefitsSection": `Beneficios_benefitsSection__JuhGy`,
	"container": `Beneficios_container__10hvC`,
	"column": `Beneficios_column__tzjOS`,
	"title": `Beneficios_title__YPF9c`,
	"benefitsList": `Beneficios_benefitsList__fFmkh`,
	"benefitItem": `Beneficios_benefitItem__mdvP1`,
	"iconWrapper": `Beneficios_iconWrapper__mBNrP`,
	"benefitContent": `Beneficios_benefitContent__fB9t-`,
	"ctaLink": `Beneficios_ctaLink__HlIaC`
};
export default ___CSS_LOADER_EXPORT___;
